import { lazy } from './lazyWithRetry';
import { Navigate, Route } from 'react-router-dom';
import { suspense } from './utils';
import { ProtectedRoleRoute } from 'utils/RequireAuth';
import { UserRoleEnum } from 'app/services/user';

const AccountantTasks = lazy(
  () =>
    import('admin/features/accountants/viewAccountantsDetails/AccoutantTasks'),
);

const ShowQuestionnaire = lazy(
  () => import('app/features/questionnaires/show'),
);

const AccountantTab = lazy(
  () => import('admin/features/accountants/viewAccountantsDetails'),
);
const AccountantProfile = lazy(
  () =>
    import(
      'admin/features/accountants/viewAccountantsDetails/AccoutantProfile'
    ),
);
const AccountantCalendar = lazy(
  () =>
    import(
      'admin/features/accountants/viewAccountantsDetails/AccountantCalendar'
    ),
);
const AccoutantTaxReturns = lazy(
  () =>
    import(
      'admin/features/accountants/viewAccountantsDetails/AccoutantTaxReturns'
    ),
);

export default function AccountantDetailsRoutes() {
  return (
    <>
      <Route
        path="accountant/:accountantId"
        element={suspense(<AccountantTab />)}
      >
        <Route path="" element={<Navigate replace to="profileInfo" />} />
        <Route path="profileInfo" element={suspense(<AccountantProfile />)} />
        <Route path="calendar" element={suspense(<AccountantCalendar />)} />

        <Route element={<ProtectedRoleRoute roles={[UserRoleEnum.ADMIN]} />}>
          <Route path="projects" element={suspense(<AccoutantTaxReturns />)} />
          <Route
            path="projects/:questionnaireId/preview"
            element={suspense(<ShowQuestionnaire preview={true} />)}
          />
          <Route path="tasks" element={suspense(<AccountantTasks />)} />
        </Route>
      </Route>
    </>
  );
}
